import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {EmailsView} from "../../components/email/EmailsView";

const Emails: NextPage = () => {
  return <>
    <Head>
      <title>Emails</title>
    </Head>
    <EmailsView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate']),
    }
  }
});


export default Emails